// extracted by css-extract-rspack-plugin
export default {"root":"a8e113d","type-info":"c45c2b6","unknown-content":"c097221","type-error":"c97a836","type-success":"e28adce","type-warning":"d81aecb","adornment":"b82d7cd","main":"da85c6d"};